const GroupTabs = ({ activeTab, onTabChange, children }) => {
  return (
    <div className="groupskg-group-tabs">
      <div className="groupskg-tabs-actions">
        <ul className="groupskg-nav groupskg-nav-tabs groupskg-small" role="tablist">
          <li className="groupskg-nav-item" role="presentation">
            <button
              className={`groupskg-nav-link ${activeTab === 'kids' ? 'groupskg-active' : ''}`}
              onClick={() => onTabChange('kids')}
            >
              Діти в групі
            </button>
          </li>
        </ul>
        <div className="groupskg-right-links">
          <a href="#">Тарифи</a>
        </div>
      </div>
      
      <div className="groupskg-tab-content">
        {children}
      </div>
    </div>
  );
};

export default GroupTabs;